import {
  StudentShortDataT,
  StudentCourseLessonDataT,
  StudentUpdateAttributes,
  StudentCoursesDataT,
} from "@interfaces/internal-study/students";

import Fetcher from "@http/fetcher";
import { ResCallback } from "@interfaces/common";

class InternalStudyStudentsService {
  static async getAll(companyId: number, cb: ResCallback<StudentShortDataT[]>) {
    try {
      const res = await Fetcher.get<StudentShortDataT[]>(
        "/educational-center/internal-training/students",
        {
          params: {
            companyId,
          },
        }
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async getById(id: number) {
    const resp = await Fetcher.get<StudentShortDataT>(
      `/educational-center/internal-training/students/${id}`
    );
    return resp.data;
  }

  static async update(
    id: number,
    data: FormData | StudentUpdateAttributes,
    cb: ResCallback<StudentShortDataT>
  ) {
    try {
      const res = await Fetcher.patch<StudentShortDataT>(
        `/educational-center/internal-training/students/${id}`,
        data
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async delete(id: number, cb: ResCallback<string>) {
    try {
      const res = await Fetcher.delete<string>(
        `/educational-center/internal-training/students/${id}`
      );

      if (res.status === 200) {
        return cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async getAllCourses(cb: ResCallback<StudentCoursesDataT[]>) {
    try {
      const res = await Fetcher.get<StudentCoursesDataT[]>(
        "/educational-center/internal-training/students/courses"
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async getCourse(id: number, cb: ResCallback<StudentCoursesDataT>) {
    try {
      const res = await Fetcher.get<StudentCoursesDataT>(
        `/educational-center/internal-training/students/courses/${id}`
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async getLesson(
    id: number,
    cb: ResCallback<StudentCourseLessonDataT>
  ) {
    try {
      const res = await Fetcher.get<StudentCourseLessonDataT>(
        `/educational-center/internal-training/students/lesson/${id}`
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async incrementStage(
    id: number,
    cb: ResCallback<StudentCoursesDataT>
  ) {
    try {
      const res = await Fetcher.get<StudentCoursesDataT>(
        `/educational-center/internal-training/students/courses/${id}/increment`
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async finish(id: number, cb: ResCallback<StudentCoursesDataT>) {
    try {
      const res = await Fetcher.get<StudentCoursesDataT>(
        `/educational-center/internal-training/students/courses/${id}/finish`
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }
}

export default InternalStudyStudentsService;
